<app-navbar></app-navbar>
<app-hero></app-hero>
<app-cursos-destacados></app-cursos-destacados>
<!--<app-video-destacado></app-video-destacado>-->
<app-beneficios></app-beneficios>
<app-payment-modes></app-payment-modes>
<app-certificaciones></app-certificaciones>
<app-footer></app-footer>